import { Injectable } from '@angular/core';
import { OperationOverlayLargeDialogComponent } from './operation-overlay-large-dialog/operation-overlay-large-dialog.component';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ListData } from '../../components/items-list/list-data.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Injectable()
export class OperationOverlayLargeNg4Service {
    constructor(private fiDialogsService: FiDialogsService) {}

    openOperationOverlayLargeDialog(
        contentComponent: IOperationOverlayLargeDialogContentComponentRef,
        contentComponentData,
        dialogData: IOperationOverlayLargeDialogData,
    ): MatDialogRef<any> {
        const d = Object.assign({}, dialogData, {
            contentData: {
                component: contentComponent,
                data: contentComponentData,
            },
        });
        const config: MatDialogConfig<IOperationOverlayLargeDialogData> = {
            panelClass: 'operation-overlay-large-panel',
            data: d,
        };
        return this.fiDialogsService.open(OperationOverlayLargeDialogComponent, config);
    }
}

export interface IOperationOverlayLargeDialogData {
    IsEditWindow?: boolean;
    IsSelectWindow?: boolean;
    multiple?: boolean;
    filterPrams?: any;
    showInsert?: boolean;
    showSave?: boolean;
    showBtnNew?: boolean;
    newClick?: () => void;
    SelectedListItem?;
    onSaveClick?: () => void;
    resultValue?: any;
    afterListLoad?: (listData: ListData<any>) => void;
    Title?: string;

    contentData?: IOperationOverlayLargeDialogContentData;
}

export interface IOperationOverlayLargeDialogContentData {
    component;
    data;
}

export interface IOperationOverlayLargeDialogContentComponentRef {
    new (...args: any[]);
}
